import { render, staticRenderFns } from "./GenerateSalePerGroup.vue?vue&type=template&id=766f83dd"
import script from "./GenerateSalePerGroup.vue?vue&type=script&lang=js"
export * from "./GenerateSalePerGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports